module.exports = __webpack_public_path__ + "img/gb5782-86-m8.prt.6c194b76.jpg";